import * as types from './mutation-type'
import api from "@/modules/api";
import { getStoreEmployees } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import state from './state';
import { cloneDeep } from 'lodash';
import router from '@/router'

const actions = {
  getMessageField({ commit }, isShow) {
    commit(types.SHOW_RECIPIENT_FIELD, isShow)
  },
  getAnnouncementField({ commit }, { isShow, isStore = false } ) {
    commit(types.SHOW_ANNOUNCEMENT_FIELD,  { isShow, isStore })
  },
  showNewMessage({ commit }, isShow) {
    commit(types.SHOW_NEW_MESSAGE, isShow)
  },
  toggleNewMessage({ commit }) {
    commit(types.NEW_MESSAGE_TOGGLE)
  },
  async createChat({ commit }, variables ) {
    try {
      commit(types.CREATE_CHAT_BEGIN)
      
      await api.chatMessenger.createChat(variables)

      commit(types.CREATE_CHAT_SUCCESS)

    } catch (e) {
      commit(types.CREATE_CHAT_ERROR, { err : e, data : variables })
    }
  },
  async retryFailedMessage({ commit }, variables) {
    try {
      commit(types.RETRY_FAILED_MESSAGES_BEGIN)

      await api.chatMessenger.createChat(variables)

      commit(types.RETRY_FAILED_MESSAGES_SUCCESS, variables)

    } catch (e) {
      commit(types.RETRY_FAILED_MESSAGES_ERROR, { err : e, data : variables })
    }
  },
  async getStoreEmployees({ commit }, variables) {
    try {
      commit(types.GET_STORE_EMPLOYEES_BEGIN)
      const { data  }  = await gqlClient.query({
        query     : getStoreEmployees,
        variables : variables
      });
      commit(types.GET_STORE_EMPLOYEES_SUCCESS,data)

    } catch (e) {
      commit(types.GET_STORE_EMPLOYEES_ERROR, e)
    }
  },

  async getConversations({ commit, rootState, dispatch }){
    try {
      commit(types.GET_CONVERSATIONS_BEGIN)
      
      const { data  }  = await api.chatMessenger.getConversations()
      
      commit(types.GET_CONVERSATIONS_SUCCESS, { data, rootState, dispatch })

      if(!state.showRedDot){
        dispatch("getUnreadMessage")
      }
      
    } catch (e) {
      commit(types.GET_CONVERSATIONS_ERROR, e)
    }
  },

  async getChatRoomMessages({ commit, getters, dispatch }, chatRoom) {
    try {
      commit(types.GET_CHATROOM_MESSAGES_BEGIN, chatRoom.id)

      const { data } = await api.chatMessenger.getChatRoomMessages(chatRoom.id)

      
      commit(types.GET_CHATROOM_MESSAGES_SUCCESS, { chatRoom, data })

      commit(types.SET_LAST_MESSAGE_RECEIVED_ID, getters.getLatestMessageId)

      if(chatRoom.id === state.activeRoomId) {
        dispatch("setMessageSeen", state.activeRoomId)
      }

    } catch (error) {
      commit(types.GET_CHATROOM_MESSAGES_ERROR, { error, chatRoom })
    }
   
  },

  async setMessageSeen({ commit, state }, chatRoomId) {
    const conversation = cloneDeep(state.conversations[chatRoomId] || state.announcements[chatRoomId])
    
    if(conversation && conversation.UnreadMessages.length){
      try {
        await api.messageStatus.setConversationsRead(chatRoomId)
      
        commit(types.UPDATE_MESSAGE_STATUS_READ_SUCCESS, conversation)
      } catch(e){
        // eslint-disable-next-line no-console
        console.log(e)
      }
    }
  },
  
  setChatRoomId({ commit, dispatch }, chatRoomId) {
    commit(types.SHOW_NEW_MESSAGE, false)
    commit(types.SET_CHAT_ROOM_ID, chatRoomId)

    dispatch("setMessageSeen", chatRoomId)
    if(!state.showRedDot){
      dispatch("getUnreadMessage")
    }
  },

  async joinChatRoom({ commit }, chatRoomId) {
    try {
      commit(types.JOIN_CHAT_ROOM_BEGIN)

      await api.chatMessenger.joinChatRoom(chatRoomId)

      commit(types.JOIN_CHAT_ROOM_SUCCESS)
    } catch (e) {
      commit(types.JOIN_CHAT_ROOM_ERROR, e)
    }
  },

  // eslint-disable-next-line
  async socket_messageReceived({ rootState, commit, dispatch }, { Message: message }) {
    const { app: { User: { id: userId } } } = rootState

    if(router.history.current.path === '/chat'){
      commit(types.SET_LAST_MESSAGE_RECEIVED_ID, message.id)

      if(userId !== message.senderId) {
        await api.messageStatus.updateMessageStatus(message.MessageStatuses.find(ms => parseInt(ms.userId) === userId).id, { 
          received : true,
          seen     : rootState.chatMessenger.activeRoomId === message.chatRoomId
        })
      }
    }
    if(!state.showRedDot){
      dispatch("getUnreadMessage")
    }
  },

  async getUnreadMessage({ commit }){
    try{
      const { data } = await api.messageStatus.getUnreadMessageLength()

      commit(types.GET_UNREAD_MESSAGE_LENGTH_SUCCESS, data)
    }catch(e){
      // eslint-disable-next-line no-console
      console.log(e)
    }
  },

  async loadMessages({ commit }, { chatRoomId, lastMessage, loaderState }) {
    try {
      commit(types.LOAD_MORE_MESSAGES_BEGIN)
      const data = await  api.chatMessenger.loadMessages(chatRoomId, lastMessage);
      if (data.data.length) {
        loaderState.loaded()
      } else {
        loaderState.complete()
      }

      commit(types.LOAD_MORE_MESSAGES_SUCCESS, data.data)
    } catch (e) {
      loaderState.error()
      commit(types.LOAD_MORE_MESSAGES_ERROR, e)
    }
  },

  updateNotificationOptions({ commit }, data) {
    commit(types.UPDATE_NOTIFICATION_OPTIONS, data)
  },
  async deleteChatHistory({ commit }, activeRoomId) {
    try {
      commit(types.DELETE_CHAT_HISTORY_BEGIN)
      const data = await  api.chatMessenger.deleteChatHistory(activeRoomId);
      
      commit(types.DELETE_CHAT_HISTORY_SUCCESS, data.data)
    } catch (e) {
      commit(types.DELETE_CHAT_HISTORY_ERROR, e)
    }
  },

  internetConnected({ commit, dispatch }) {
    commit(types.INTERNET_CONNECTED, { dispatch })
  }
}

export default actions